export const KIND_ORDER = { MAIN: 0, FALLBACK: 1, CUSTOM: 2 } as const
